export interface JsonObj {
    sourceApp?: any;
    date?: any;
    screenToShow?: any;
    data?: any;
    credentials?: any;
    userInfo?: any;
}
